/** The codes in a note's billing code: "90839 + 90840 x2" → 90839, 90840; "H0038 x2" → H0038. */
export function codesIn(code) {
    return String(code || '')
        .split('+')
        .map((p) => p.trim().split(/\s+/)[0]?.toUpperCase() ?? '')
        .filter(Boolean);
}
/** The modifier the billing line carries for this place (V81 billingLine; 95 / 93 when not set). */
export function billingModifier(place, rules) {
    if (place === 'Telehealth')
        return rules?.videoModifier || '95';
    if (place === 'Phone')
        return rules?.phoneModifier || '93';
    return '';
}
/** What the payor's rules say about this code and place (V81 billingChecks, the payor part). */
export function payorChecks(code, place, rules) {
    if (!rules)
        return [];
    const out = [];
    const name = rules.name || 'This payor';
    if (Array.isArray(rules.coveredCodes)) {
        const covered = new Set(rules.coveredCodes.map((c) => String(c).toUpperCase()));
        for (const c of codesIn(code))
            if (!covered.has(c))
                out.push(`${name} doesn't cover ${c}.`);
    }
    if (place === 'Phone' && rules.paysPhone === false)
        out.push(`${name} doesn't pay phone (audio-only) sessions.`);
    return out;
}
//# sourceMappingURL=payorRules.js.map